import { FC } from "react";
import { styled } from "@mui/material/styles";
import MaterialSwitch, { SwitchProps } from "@mui/material/Switch";
import { COLOR_WHITE, COLOR_SHAMROCK, COLOR_ALTO } from "../../constants/styles";

const StyledSwitch = styled(MaterialSwitch)((props) => ({
  padding: 10,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    opacity: 1,
    backgroundColor: `${COLOR_ALTO} !important`,
  },
  "& .Mui-checked": {
    color: COLOR_SHAMROCK,
  },
  "& .Mui-checked+.MuiSwitch-track": {
    backgroundColor: `${COLOR_SHAMROCK} !important`,
    opacity: `1 !important`,
  },
  "& .Mui-disabled+.MuiSwitch-track": {
    opacity: `1 !important`,
  },
  "& .Mui-disabled": {
    cursor: "not-allowed !important"
  },
  "& .MuiSwitch-switchBase": {
    padding: 12,
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: COLOR_WHITE,
    boxShadow: "none",
    width: 10,
    height: 10,
    margin: 2,
  },
}));

export const Switch: FC<SwitchProps> = (props) => {
  return <StyledSwitch {...(props as any)} color="success" />;
};

export type { SwitchProps };
